import React from 'react';
import { ArticleHeader, ArticleHeaderProps } from '../../components/ArticleHeader/ArticleHeader';
import { BreadcrumbProps, Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { CompetitionBlock, CompetitionBlockProps } from '../../components/CompetitionBlock/CompetitionBlock';
import { ContentBlock } from '@jbhi-fi/components/src/ContentBlock';
import { useCompetitionProps } from '../../hooks/content/useCompetitionProps';
import { ArticleRichTextLayoutBlockContextProvider } from '../../hooks/useArticleRichTextLayoutBlockProps';
import { styles } from './Competition.css';
import { RelatedEntries, RelatedEntriesProps } from '../../components/RelatedEntries/RelatedEntries';
import { Disclaimer } from '@jbhi-fi/components/src/Disclaimer';

export type CompetitionProps = {
  header: ArticleHeaderProps;
  breadcrumbs: BreadcrumbProps;
  competitionBlock: CompetitionBlockProps;
  relatedEntries?: RelatedEntriesProps;
  competitionId: string;
  enteredOn?: string;
  isCompetitionPerksOnly?: boolean;
  isUserPerks?: boolean;
};

export const Competition = () => {
  const {
    data: { header, breadcrumbs, competitionBlock, relatedEntries, enteredOn, isCompetitionPerksOnly },
    isLoading,
    error,
  } = useCompetitionProps();

  const pagePathname = window.location.pathname;
  const competitionPageSlugSetting = window.Jbhifi.competitionPageSlug;
  const competitionAnnouncedSetting = window.Jbhifi.competitionWinnersAnnouncedOverride;
  const competitionEndSetting = window.Jbhifi.competitionClosesOverride;
  const competitionWinnersAnnouncementLabelOverride =
    pagePathname.includes(`/blogs/competitions/${competitionPageSlugSetting}`) && competitionAnnouncedSetting
      ? competitionAnnouncedSetting
      : '';
  const competitionEndLabelOverride =
    pagePathname.includes(`/blogs/competitions/${competitionPageSlugSetting}`) && competitionEndSetting
      ? competitionEndSetting
      : '';

  if (isLoading || error) return null;

  return (
    <>
      <Breadcrumbs className={styles.breadcrumbs} {...breadcrumbs} />
      <ContentBlock
        backgroundColor="primary.light"
        paddingTop={0}
        paddingLeft={0}
        paddingRight={0}
        paddingBottom={{ mobile: 10, tablet: 20 }}
      >
        <div className={styles.pageContainer}>
          <ArticleHeader {...header} />
          <div className={styles.competitionBlock}>
            <ArticleRichTextLayoutBlockContextProvider paddingTop={{ mobile: 5, desktop: 5, desktopLg: 5 }}>
              <CompetitionBlock
                {...competitionBlock}
                enteredOn={enteredOn}
                isCompetitionPerksOnly={isCompetitionPerksOnly}
                winnersAnnouncementLabelOverride={competitionWinnersAnnouncementLabelOverride}
                endLabelOverride={competitionEndLabelOverride}
              />
            </ArticleRichTextLayoutBlockContextProvider>
            <ContentBlock paddingTop={15} paddingBottom={0} paddingX={{ xs: 4, md: 8 }}>
              <Disclaimer disclaimers={window.Jbhifi.disclaimers} />
            </ContentBlock>
          </div>
        </div>
      </ContentBlock>
      {relatedEntries.filter ? (
        <ContentBlock
          backgroundColor="secondary.dark"
          paddingBottom={{ mobile: 10, tablet: 16 }}
          paddingLeft={0}
          paddingRight={0}
          paddingTop={15}
        >
          <ContentBlock paddingTop={0}>
            <RelatedEntries {...relatedEntries} />
          </ContentBlock>
        </ContentBlock>
      ) : null}
    </>
  );
};
